<template>
<div>
    <b-container>
        <b-row>
            <b-col cols="4"></b-col>
            <b-col cols="4" v-if="saleOpen && isApproved">
                <br><br>
                    <b-card class="col-sm-12 col-md-6 col-lg-4 d-flex align-self-stretch clabs">
                        <img  alt="" class="imageCard">
                        <h4>DriveThru Duck</h4>
                        <br>
                        <img class="collectImg" src="../../assets/collectibles/drivethru.gif" alt="">
                        <br><br>
                        <h6>{{totalMinted}} / {{maxForSale}} Minted!</h6>
                        <br>
                        <input v-if="!loadingTransaction && (Number(this.totalMinted) < Number(this.maxForSale))" type="number" min="1" v-model="mintAmount" class="mintInput">
                        <button v-if="!loadingTransaction && (Number(this.totalMinted) < Number(this.maxForSale))" @click="mintCollectible()" class="button-42">{{cutPrice}} CUT</button>
                        
                        
                        <b-icon v-if="loadingTransaction" icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon>
                    </b-card>
            </b-col>
            <b-col cols="4" v-if="saleOpen && !isApproved">
                <br><br>
                <b-card class="col-sm-12 col-md-6 col-lg-4 d-flex align-self-stretch clabs">
                        <button v-if="!loadingTransaction" @click="approveTokens()" class="button-42">Approve Collectible Spending</button>

                        <b-icon v-if="loadingTransaction" icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon>
                    </b-card>
            </b-col>

            <b-col cols="4"></b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
import tokenContractInfo from '../../assets/contracts/newCut.json'
import collectibleContractInfo from '../../assets/contracts/collectibles.json'
import Web3 from 'web3';
export default {
    data: function () {
        return {
            walletAddress: '',
            walletBalance: '',
            tokenAmount: 0,

            cutPrice: 0,
            maxForSale: 0,
            totalMinted: 0,

            mintAmount: 1,

            saleOpen: false,
            isApproved: false,

            web3: '',



            tokenContract: '',
            tokenContractAbi: tokenContractInfo.abi,
            tokenContractAddress: tokenContractInfo.contractAddress,

            loadingTransaction: false,

            collectContract: '',
            collectContractAbi: collectibleContractInfo.abi,
            collectContractAddress: collectibleContractInfo.contractAddress,
        }
    },
    mounted()
    {
        this.LoadEthWallet();
    },
    methods:{
        mintCollectible()
        {   
            
            if(this.tokenAmount >= this.cutPrice * this.mintAmount)       
            {
                this.loadingTransaction = true;

                this.collectContract.methods.MintCosmicCollectible(this.mintAmount).send({from: this.walletAddress})
                .on('confirmation', function(confirmationNumber, receipt){

                })
                .then(res=>{
                    alert("Congrats, You Minted!");
                    this.LoadTokenInfo();
                    this.loadingTransaction = false;
                })
                .catch(err=>{
                    this.loadingTransaction = false;
                })
            }
        },
        approveTokens()
        {
            this.loadingTransaction = true;

            this.tokenContract.methods.approve(this.collectContractAddress, this.web3.utils.toWei('1000000000', 'ether')).send({from: this.walletAddress})
            .on('confirmation', function(confirmationNumber, receipt){

            })
            .then(res=>{
                alert("You are approved to access the Collectible Drops!");
                this.LoadTokenInfo();
                this.loadingTransaction = false;
            })
            .catch(err=>{
                this.loadingTransaction = false;
            })
        },
        async chainChange()
        {
            await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: '0x1' }], // chainId must be in hexadecimal numbers
                    });
                    this.LoadEthWallet();
        },
        async LoadTokenInfo(){
            this.tokenContract = new this.web3.eth.Contract(this.tokenContractAbi, this.tokenContractAddress);
            
            this.tokenContract.methods.balanceOf(this.walletAddress).call({})
            .then(res=>{
                this.tokenAmount = this.web3.utils.fromWei(res, 'ether');
            })

            this.tokenContract.methods.allowance(this.walletAddress, this.collectContractAddress).call({})
            .then(res=>{
                if(Number(this.web3.utils.fromWei(res, "ether")) > 10000)
                {
                    this.isApproved = true;
                }
                else
                {
                    this.isApproved = false;
                }
            })

            this.collectContract = await new this.web3.eth.Contract(this.collectContractAbi, this.collectContractAddress);

            await this.collectContract.methods.cutPrice().call({})
            .then(res=>{
                this.cutPrice = this.web3.utils.fromWei(res, 'ether');
            })

            await this.collectContract.methods.maxIdsForSale().call({})
            .then(res=>{
                this.maxForSale = res;
            })

            await this.collectContract.methods.totalTokens().call({})
            .then(res=>{
                this.totalMinted = res;
            })

            await this.collectContract.methods.saleOpen().call({})
            .then(res=>{
                this.saleOpen = res;
            })

        },
        LoadEthWallet: function(){
            
            if (typeof window.ethereum !== 'undefined') 
                {
                    ethereum.enable();
                    this.web3 = new Web3(this.walletConnect || window.ethereum || new Web3.providers.HttpProvider("https://mainnet.infura.io/v3/1xVMLkEDl6htSmYN7YeFXGvIe07") || Web3.givenProvider);
                    this.web3.eth.net.getNetworkType()
                    .then(network=>{
                        if(network == "main")
                        {
                            this.web3.eth.requestAccounts()
                            .then(acc=>{
                                this.walletAddress = acc[0];
                                this.web3.eth.getBalance(this.walletAddress)
                                .then(balance=>{
                                    this.walletBalance = this.web3.utils.fromWei(balance, "ether");     
                                    this.LoadTokenInfo();
                                });
                            })
                            .catch(err=>{
                                console.log(err);
                            })            
                        }
                        else{
                            this.chainChange();
                        }          
                    })
                }

            
        },
    },
    watch: {
          walletAddress: function(val) {
            window.ethereum.on("accountsChanged", accounts => {
              if (accounts.length > 0)
              {
                this.walletAddress = accounts[0];
                this.web3.eth.getBalance(this.walletAddress)
                .then(balance=>{
                  this.walletBalance = this.web3.utils.fromWei(balance, "ether");     
                });
                this.LoadTokenInfo();
              } 
              else 
              {
                this.walletAddress = '';
                this.walletBalance = '';
              }
            })
          },
          walletBalance: function(val)
          {
            window.ethereum.on("balanceChanged", balance => 
            {
              this.walletBalance = balance;
              this.LoadTokenInfo();
            })
            
          },
    },

}
</script>

<style scoped>
.collectImg
{
    width: 100%;
}

.mintInput
{
    border: 2px solid black;
    border-radius: 10px;
    text-align: center;
    width: 8vh;
    display: inline-block;
    line-height: 40px;
}

.button-42 {
  background-color: initial;
  background-image: linear-gradient(-180deg, #eca0f2, #d273ed);
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;
  color: #FFFFFF;
  cursor: pointer;
  display: inline-block;
  font-family: Inter,-apple-system,system-ui,Roboto,"Helvetica Neue",Arial,sans-serif;
  height: 40px;
  line-height: 40px;
  outline: 0;
  overflow: hidden;
  padding: 0 20px;
  pointer-events: auto;
  position: relative;
  text-align: center;
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  vertical-align: top;
  white-space: nowrap;
  width: 15vh;
  z-index: 9;
  border: 0;
  transition: box-shadow .2s;
}

.button-42:hover {
  box-shadow: #b833e8 0 3px 8px;
}
.clabs
{
    width: 100%;
    display: flex !important;
    margin-bottom: 2vh;
    border: 4px solid #5E5DF0
}
</style>


// WEBPACK FOOTER //
// src/components/Store/collectibles.vue